// Generic status-filter tab bar — shared by any "list of records with a lifecycle status"
// screen (currently: student invites in Enroll.tsx, instructor invites in Instructors.tsx).
// Purely presentational: the caller owns which key is active and what counts to show.
export function StatusTabs<T extends string>({
  tabs, active, onChange,
}: {
  tabs: { key: T; label: string; count: number }[]
  active: T
  onChange: (key: T) => void
}) {
  return (
    <div style={{ display: 'flex', gap: 4, padding: '0 22px', borderBottom: '1px solid rgba(27,42,74,0.06)' }}>
      {tabs.map(t => (
        <button
          key={t.key}
          onClick={() => onChange(t.key)}
          style={{
            padding: '12px 14px 10px', background: 'none',
            border: 'none', borderBottom: active === t.key ? '2px solid #0F7C6C' : '2px solid transparent',
            font: active === t.key ? '600 13px Inter, sans-serif' : '500 13px Inter, sans-serif',
            color: active === t.key ? '#1B2A4A' : 'rgba(27,42,74,0.5)',
            cursor: 'pointer', marginBottom: -1,
          }}
        >
          {t.label} ({t.count})
        </button>
      ))}
    </div>
  )
}
